import { tv, type VariantProps } from "tailwind-variants";

export const caseCardVariant = tv({
  slots: {
    base: [
      "flex flex-col items-start",
      "bg-gray-600",
      "rounded-xl",
      "overflow-hidden",
    ],
    figureWrapper: ["w-full"],
    figure: [
      "h-[200px] w-full",
      "overflow-hidden",
      "focus-within:outline focus-within:outline-2",
      "relative",
      "after:absolute after:mt-auto after:bottom-0 after:inset-0",
      "after:w-full after:h-full",
      "after:bg-gradient-to-b after:from-transparent after:to-black/80",
      "z-1",
    ],
    image: ["object-cover"],
    logo: [
      "absolute top-0 right-0",
      "w-full h-full",
      "flex items-center justify-center",
      "p-20",
      "z-10",
    ],
    link: ["block border-b border-gray-600 last:border-none"],
    textWrapper: ["p-6", "flex flex-col gap-4"],
    category: ["text-blue-400"],
    title: ["text-white hover:text-blue-400"],
    description: ["text-gray-60"],
  },
});

export type CaseCardVariantProps = VariantProps<typeof caseCardVariant>;
